import type { BetterAuthPlugin, BetterAuthClientPlugin } from 'better-auth';

// BetterAuth plugin to add references to our internal accounts
// Mainly needed so that the `user.toroAccount` field gets handled correctly as an ObjectId/string
export const toroAccountPlugin = {
  id: 'toro-account-plugin',
  schema: {
    toroAccount: {
      fields: {
        name: {
          type: 'string',
          required: true,
        },
        isInternal: {
          type: 'boolean',
          defaultValue: false,
          input: false,
        },
      },
      modelName: 'accounts',
    },
  },
} as const satisfies BetterAuthPlugin;

const INFERRED_SERVER_PLUGIN = {} as typeof toroAccountPlugin;

// Client-side plugin for inferring types
export const toroAccountClientPlugin = {
  id: toroAccountPlugin.id,
  $InferServerPlugin: INFERRED_SERVER_PLUGIN,
} as const satisfies BetterAuthClientPlugin;
